import { render, staticRenderFns } from "./AdminAttributeMetrics.vue?vue&type=template&id=3c4b7599&scoped=true"
import script from "./AdminAttributeMetrics.vue?vue&type=script&lang=js"
export * from "./AdminAttributeMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4b7599",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c4b7599')) {
      api.createRecord('3c4b7599', component.options)
    } else {
      api.reload('3c4b7599', component.options)
    }
    module.hot.accept("./AdminAttributeMetrics.vue?vue&type=template&id=3c4b7599&scoped=true", function () {
      api.rerender('3c4b7599', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/managment/AdminAttributeMetrics.vue"
export default component.exports